'use client'
import { useEffect } from 'react'

export default function PlausibleProvider() {
  useEffect(() => {
    const domain = process.env.NEXT_PUBLIC_PLAUSIBLE_DOMAIN
    if (!domain) return
    import('@plausible-analytics/tracker').then(({ init }) => {
      try {
        init({ domain, autoCapturePageviews: true, bindToWindow: true })
      } catch {}
    })
  }, [])
  return null
}
